var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2TvRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM23 26h29a4 4 0 014 4v10h-4V30H23v17h22v4h-5v5h5v4H30v-4h6v-5H23a4 4 0 01-4-4V30a4 4 0 014-4zm26 34h7V44h-7v16zm2-13h3v2h-3v-2zm0 4h3v2h-3v-2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_TV_room.f1f44ddd.svg";
export { SvgE2TvRoom as ReactComponent };